
/* ══════════════════════════════════════════════
   CART ICON — fetch count, update badge, bump
══════════════════════════════════════════════ */
var azCart = {
  btn:   null,
  badge: null,

  init: function() {
    azCart.btn   = document.getElementById('az-cart-btn');
    azCart.badge = document.getElementById('az-cart-count');
    azCart.refresh();  /* show existing cart items on load */
  },

  /* Fetch current cart count from Shopify */
  refresh: function() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { azCart.setCount(cart.item_count); })
      .catch(function() {});
  },

  setCount: function(n) {
    if (!azCart.badge) return;
    azCart.badge.textContent = n > 99 ? '99+' : String(n);
    if (n > 0) {
      azCart.badge.classList.add('visible');
    } else {
      azCart.badge.classList.remove('visible');
    }
  },

  /* Call after a successful add-to-cart */
  bump: function(newCount) {
    azCart.setCount(newCount);
    if (!azCart.btn) return;
    azCart.btn.classList.remove('bump');
    void azCart.btn.offsetWidth;  /* force reflow to restart animation */
    azCart.btn.classList.add('bump');
    setTimeout(function() { azCart.btn.classList.remove('bump'); }, 500);
  }
};

/* Initialise cart icon once DOM is ready */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', azCart.init);
} else {
  azCart.init();
}

window.AZZURRA_ASSETS = window.AZZURRA_ASSETS || {};
var azShopify = {
  isShopify: typeof Shopify !== "undefined" ||
    !!document.querySelector("meta[name=shopify-checkout-api-token]"),
  addToCart: function(vid, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({id: vid, quantity: qty || 1})
    }).then(function(r){ return r.json(); });
  },
  buyNow: function(vid, qty) {
    azShopify.addToCart(vid, qty).then(function(){ window.location.href="/checkout"; })
      .catch(function(){ window.location.href="/cart"; });
  },
  addAndNotify: function(vid, qty) {
    var btn = document.getElementById("pdp-add-btn");
    if (btn) { btn.disabled = true; btn.textContent = "Adding..."; }
    azShopify.addToCart(vid, qty).then(function(item) {
      /* Update cart icon */
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){azCart.bump(c.item_count);}).catch(function(){});
      if (btn) {
        btn.textContent = "Added to Cart";
        btn.style.background = "#5dbd79";
        setTimeout(function() {
          btn.innerHTML = "<span class=\"pdp-add-circle\"><svg width=\"10\" height=\"10\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2.5\" stroke-linecap=\"round\"><line x1=\"12\" y1=\"5\" x2=\"12\" y2=\"19\"/><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"/></svg></span>Add to Cart";
          btn.style.background = ""; btn.disabled = false;
        }, 2000);
      }
    }).catch(function(){ if(btn){btn.textContent="Add to Cart";btn.disabled=false;} });
  }
};
function applyShopifyOverrides(perfumes) {
  var s = window.AZZURRA_SETTINGS;
  if (!s || !s.perfumes || !s.perfumes.length) return perfumes;
  var map = {};
  s.perfumes.forEach(function(o){ if(o&&o.name) map[o.name.trim().toLowerCase()] = o; });
  return perfumes.map(function(p) {
    var o = map[p.name.trim().toLowerCase()] || {};
    return Object.assign({}, p, {
      name:      o.name      || p.name,
      tagline:   o.tagline   || p.tagline,
      desc:      o.desc      || p.desc,
      price:     o.price     || p.price,
      top:       o.top       || p.top,
      heart:     o.heart     || p.heart,
      base:      o.base      || p.base,
      color:     o.color     || p.color,
      accent:    o.accent    || p.accent,
      img:       o.img       || p.img,
      variantId: o.variantId != null ? o.variantId : (p.variantId||null)
    });
  });
}

(function () {

/* ══════════════════════════════════════════════════
   SVG FILTER: Remove white JPEG backgrounds cleanly.
   feColorMatrix makes pixels where R+G+B > 2.55
   transparent — no darkening, no blend modes needed.
══════════════════════════════════════════════════ */
(function() {
  var ns  = 'http://www.w3.org/2000/svg';
  var svg = document.createElementNS(ns, 'svg');
  svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  svg.innerHTML =
    '<defs>' +
    '<filter id="az-rm-white" color-interpolation-filters="sRGB">' +
    '<feColorMatrix type="matrix" values="' +
      '1 0 0 0 0  ' +   /* R = R */
      '0 1 0 0 0  ' +   /* G = G */
      '0 0 1 0 0  ' +   /* B = B */
      '-1 -1 -1 0 2.55' + /* A = 2.55 - R - G - B  (white → 0, colours → 1) */
    '"/>' +
    '</filter>' +
    '</defs>';
  document.head.appendChild(svg);
})();

'use strict';

/* ══════════════════════════════════════════════
   PERFUME DATA — 6 fragrances
══════════════════════════════════════════════ */
var P = [
  {
    name:     'Azure Afternoon',
    img:      window.AZZURRA_ASSETS['bottle-azure.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'Passionate Citrus, Boundless Pleasure.',
    italic:   'Sunlit waves and the revitalizing embrace of summer.',
    desc:     'Experience the luminous energy of Azure Afternoon — a masterful creation celebrating the timeless beauty of citrus. At its heart lies rare Sicilian orange, lush and bursting with juice. Sparkling bergamot harmonizes with the delicate sweetness of mandarin in a wave of radiant delight. Subtle ginger adds refined warmth, while ambergris lingers like the memory of a sea breeze.',
    top:      'Mandarin Orange · Sicilian Orange',
    heart:    'Bergamot · Citrus',
    base:     'Amber Gris · Ginger',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44183887708340,
    color:    '#C5D8F5',
    accent:   '#4A7FC1',
    hasVideo: true,
    video:    'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260405_170732_8a9ccda6-5cff-4628-b164-059c500a2b41.mp4',
    gradient: 'radial-gradient(ellipse 70% 60% at 35% 58%, rgba(18,65,200,0.28) 0%, transparent 68%), linear-gradient(160deg, #000611 0%, #000c25 50%, #000210 100%)',
    cardGrad: 'linear-gradient(135deg, #000c20 0%, #001540 50%, #000820 100%)'
  },
  {
    name:     'Golden Amber',
    img:      window.AZZURRA_ASSETS['bottle-amber.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'A Symphony of Opulence.',
    italic:   'Timeless elegance, crafted from 219 carefully chosen components.',
    desc:     'Golden Amber embodies timeless elegance, blending radiant florals, warm tobacco, and rich amber for a scent of pure indulgence. A burst of bitter orange awakens the senses, lifting delicate tuberose and jasmine with freshness. As it deepens, blonde tobacco adds a smoky sophistication, while tonka bean and vanilla create a smooth, gourmand finish — versatile and complex, leaving a lasting impression of warmth and luxury.',
    top:      'Olibanum · Bitter Orange · Cardamom · Bergamot',
    heart:    'White Tobacco · Sandalwood · Tuberose · Jasmine',
    base:     'Tonka Bean · Vanilla · Cedarwood · Labdanum',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44183887872180,
    color:    '#F5E0C5',
    accent:   '#C0392B',
    hasVideo: true,
    videoType:'noir',
    video:    'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260328_083109_283f3553-e28f-428b-a723-d639c617eb2b.mp4',
    gradient: 'radial-gradient(ellipse 60% 55% at 42% 55%, rgba(160,15,15,0.32) 0%, transparent 65%), radial-gradient(ellipse at 78% 22%, rgba(100,5,5,0.2) 0%, transparent 55%), linear-gradient(160deg, #0e0000 0%, #1c0404 45%, #0a0000 75%, #060000 100%)',
    cardGrad: 'linear-gradient(135deg, #1a0000 0%, #2e0505 50%, #120000 100%)'
  },
  {
    name:     'Aqua Elixir',
    img:      window.AZZURRA_ASSETS['bottle-aqua.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'The Essence of Freedom and Freshness.',
    italic:   'An exhilarating journey into limitless possibilities.',
    desc:     'Aqua Elixir is a celebration of freshness where sparkling citrus awakens the senses with zesty brilliance. Black tea, sourced from China and delicately extracted using CO2 technology, adds rich aromatic character and refinement. A generous dose of Ambrox — perfumery\'s "white gold" — creates a modern, sensual depth that is both captivating and contemporary.',
    top:      'Citrus · Lemon · Orange',
    heart:    'Ambrox · Black Tea',
    base:     'Neroli · Rosemary',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44183887806644,
    color:    '#C5E8FA',
    accent:   '#2980B9',
    hasVideo: true,
    videoType:'rose',
    video:    'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260429_114316_1c7889ad-2885-410e-b493-98119fee0ddb.mp4',
    gradient: 'radial-gradient(ellipse 65% 55% at 38% 55%, rgba(20,100,180,0.28) 0%, transparent 65%), linear-gradient(160deg, #000811 0%, #001020 42%, #000812 70%, #000408 100%)',
    cardGrad: 'linear-gradient(135deg, #001020 0%, #002040 50%, #001020 100%)'
  },
  {
    name:     'Oud Enigma',
    img:      window.AZZURRA_ASSETS['bottle-oud.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'A Journey of Sophistication & Mystery.',
    italic:   'Bold, sophisticated, and unforgettable.',
    desc:     'Oud Enigma captures the untamed beauty of the desert with rare, exceptional ingredients. At its heart, oud wood exudes smoky, resinous depth, balanced by warm amber resins for a smooth, luxurious finish. The richness of saffron, raspberry, and incense rose adds intrigue, while birch and benzoin create a lasting impression of strength and refinement. An experience — a journey through time and nature.',
    top:      'Agarwood · Incense Rose · Oud Wood',
    heart:    'Raspberry · Saffron · Amber Wood',
    base:     'Birch · Benzoin · Geranium',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44186749632692,
    color:    '#FAE5B0',
    accent:   '#C8860A',
    hasVideo: true,
    videoType:'oud',
    video:    'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260406_094145_4a271a6c-3869-4f1c-8aa7-aeb0cb227994.mp4',
    gradient: 'radial-gradient(ellipse 65% 55% at 40% 58%, rgba(200,120,10,0.28) 0%, transparent 65%), radial-gradient(ellipse at 78% 22%, rgba(180,90,5,0.2) 0%, transparent 55%), linear-gradient(160deg, #0d0700 0%, #1c0e00 42%, #0e0700 72%, #060400 100%)',
    cardGrad: 'linear-gradient(135deg, #1a0c00 0%, #301800 50%, #150a00 100%)'
  },
  {
    name:     'Emerald Wade',
    img:      window.AZZURRA_ASSETS['bottle-emerald.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'A Symphony of Fresh Horizons.',
    italic:   'The invigorating energy of daybreak over the ocean.',
    desc:     'Emerald Wade captures the rejuvenating spirit of nature, opening with vibrant blackcurrant and cédrat evoking cool ocean waves. Zesty lemon and coriander add brightness, while basil and peppermint create a balanced, soothing accord that revitalizes. A testament to modern luxury and sustainability, presented in a refillable bottle of timeless elegance.',
    top:      'Orange · Mint · Lemon · Black Currant · Coriander',
    heart:    'Apricot · Basil · Carrot Seeds',
    base:     'Fig · Dates · Ambrette',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44183883317428,
    color:    '#B8E8C8',
    accent:   '#2E7D4F',
    hasVideo: true,
    videoType:'emerald',
    video:    'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260511_131941_d136af49-e243-493a-be14-6ff3f24e09e6.mp4',
    gradient: 'radial-gradient(ellipse 65% 55% at 38% 52%, rgba(20,120,60,0.25) 0%, transparent 65%), radial-gradient(ellipse at 75% 25%, rgba(15,90,40,0.18) 0%, transparent 55%), linear-gradient(160deg, #010d04 0%, #021a08 42%, #010d04 72%, #010602 100%)',
    cardGrad: 'linear-gradient(135deg, #011008 0%, #021e0d 50%, #010c05 100%)'
  },
  {
    name:     'Opulent Rose',
    img:      window.AZZURRA_ASSETS['bottle-rose.jpg'],
    sub:      'Extrait de Parfum · Unisex · 100ml',
    tagline:  'A Luxurious Tapestry of Bold Elegance.',
    italic:   'The symbol of timeless femininity in its most opulent form.',
    desc:     'Opulent Rose unfolds with the sumptuousness of peach and blossom — a burst of fruity sweetness capturing spring in full bloom. Oud adds an immediate exotic depth and sophistication. At the heart, leather, saffron, and rose bring warmth and velvety intrigue. The base softens into vanilla, praline, and musk, leaving a sensual and unforgettable trail.',
    top:      'Peach · Blossom · Oud',
    heart:    'Leather · Saffron · Rose',
    base:     'Vanilla · Praline · Musk',
    conc:     '30% Perfume Concentrate',
    price:    '$89.99',
    variantId: 44186882080948,
    color:    '#F5C5D8',
    accent:   '#9B4060',
    hasVideo: true,
    videoType:'opulent',
    video:    '',
    gradient: 'radial-gradient(ellipse 65% 55% at 38% 55%, rgba(160,30,80,0.28) 0%, transparent 65%), radial-gradient(ellipse at 74% 24%, rgba(120,20,60,0.2) 0%, transparent 55%), linear-gradient(160deg, #0e0005 0%, #1a0510 42%, #0c0008 70%, #060003 100%)',
    cardGrad: 'linear-gradient(135deg, #1a0010 0%, #300520 50%, #150008 100%)'
  }
];
P = applyShopifyOverrides(P);

/* ══════════════════════════════════════════════
   STATE
══════════════════════════════════════════════ */
var active = 0;        /* current perfume index */
var transitioning = false;

/* ══════════════════════════════════════════════
   HELPERS
══════════════════════════════════════════════ */
var G = function (id) { return document.getElementById(id); };
var SP = '<span style="display:inline-block;width:0.26em;"></span>';

function buildWords (text, delay, cls) {
  cls = cls || '';
  return text.split(' ').map(function (w, i) {
    var d = (delay + i * 0.08).toFixed(2);
    return '<span class="word ' + cls + '" style="animation-delay:' + d + 's;">' + w + '</span>' + SP;
  }).join('');
}
function runWords (el) {
  if (!el) return;
  el.querySelectorAll('.word').forEach(function (w) { w.classList.add('run'); });
}
function runFu (el) { if (el) el.classList.add('run'); }

/* ══════════════════════════════════════════════
   BUILD NAVBAR TABS
══════════════════════════════════════════════ */
var navbar = G('navbar');
P.forEach(function (perf, i) {
  var btn = document.createElement('button');
  btn.className = 'tab-btn' + (i === 0 ? ' active' : '');
  btn.textContent = perf.name;
  btn.style.borderBottomColor = i === 0 ? perf.color : 'transparent';
  btn.addEventListener('click', function () { switchTo(i); });
  navbar.appendChild(btn);
});
var tabs = navbar.querySelectorAll('.tab-btn');

/* ══════════════════════════════════════════════
   BUILD COLLECTION GRID
══════════════════════════════════════════════ */
var grid = G('coll-grid');
P.forEach(function (perf, i) {
  var card = document.createElement('div');
  card.className = 'coll-card si' + (i === 0 ? ' active' : '');
  card.style.animationDelay = (i * 0.1) + 's';
  var bgStyle = perf.img
    ? 'background:' + perf.cardGrad + ';'
    : 'background:' + perf.cardGrad + ';';
  var imgTag = perf.img
    ? '<img src="' + perf.img + '" alt="' + perf.name + '">'
    : '';
  card.innerHTML =
    '<div class="coll-card-bg" style="' + bgStyle + '">' + imgTag + '</div>' +
    '<div class="coll-card-overlay"></div>' +
    '<span class="coll-card-num">0' + (i+1) + '</span>' +
    '<div class="coll-card-info">' +
      '<div class="coll-card-name">' + perf.name + '</div>' +
      '<div class="coll-card-price">' + perf.price + '</div>' +
    '</div>';
  card.addEventListener('click', function () {
    switchTo(i);
    /* Slight delay so the tab switch + background crossfade fires first */
    setTimeout(function () { openPDP(P[i]); }, 60);
  });
  grid.appendChild(card);
});

/* ══════════════════════════════════════════════
   BUILD COLLECTION HEADER WORDS
══════════════════════════════════════════════ */
G('coll-title-words').innerHTML = buildWords('Discover the full collection.', 0);
G('coll-sub-words').innerHTML   = buildWords('Six scents. Six worlds. One house.', 0.3);

/* ══════════════════════════════════════════════
   NOIR OUD — seamless two-video crossfade loop
   noirActive plays. When it's 1s from ending,
   noirStandby starts from 0 and fades in while
   noirActive fades out → swap → repeat forever.
   Result: looks like a living photo, never stops.
══════════════════════════════════════════════ */
var NOIR_SRC = 'https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260328_083109_283f3553-e28f-428b-a723-d639c617eb2b.mp4';
var noirA    = G('noir-a');
var noirB    = G('noir-b');
var noirGrad = G('noir-grad');
var noirRaf  = null;
var noirAct  = noirA;   /* currently visible/playing  */
var noirSby  = noirB;   /* standby, next to crossfade */
var XFADE    = 1.0;     /* crossfade duration seconds  */
var xfading  = false;

function noirTick () {
  var d = noirAct.duration;
  var t = noirAct.currentTime;

  if (!isNaN(d) && d > 0) {
    if (t >= d - XFADE && !xfading) {
      /* Begin crossfade: start standby video */
      xfading = true;
      noirSby.currentTime = 0;
      noirSby.play();
    }

    if (xfading) {
      /* How far through the crossfade? 0→1 */
      var progress = Math.max(0, Math.min(1, (t - (d - XFADE)) / XFADE));
      noirAct.style.opacity = 1 - progress;
      noirSby.style.opacity = progress;

      if (progress >= 0.999) {
        /* Crossfade done — swap roles */
        noirAct.pause();
        noirAct.style.opacity = '0';
        var tmp = noirAct;
        noirAct = noirSby;
        noirSby = tmp;
        xfading = false;
        /* noirAct is now fully visible, noirSby ready for next cycle */
      }
    } else {
      noirAct.style.opacity = '1';
      noirSby.style.opacity = '0';
    }
  }

  noirRaf = requestAnimationFrame(noirTick);
}

function startNoir () {
  /* Reset state */
  xfading = false;
  noirAct = noirA; noirSby = noirB;
  [noirA, noirB].forEach(function (v) {
    v.style.display = 'block';
    v.style.opacity = '0';
    v.pause();
    v.currentTime = 0;
  });
  noirGrad.style.opacity = '1';

  /* Start primary video, then kick off RAF loop */
  noirAct.play().then(function () {
    noirAct.style.opacity = '1';
    cancelAnimationFrame(noirRaf);
    noirTick();
  }).catch(function () {
    noirAct.style.opacity = '1';
    cancelAnimationFrame(noirRaf);
    noirTick();
  });
}

function stopNoir () {
  cancelAnimationFrame(noirRaf);
  xfading = false;
  [noirA, noirB].forEach(function (v) {
    v.pause();
    v.style.opacity = '0';
  });
  noirGrad.style.opacity = '0';
  setTimeout(function () {
    noirA.style.display = 'none';
    noirB.style.display = 'none';
  }, 700);
}

/* ══════════════════════════════════════════════
   ROSE DE TAIF — identical crossfade engine
══════════════════════════════════════════════ */
var roseA    = G('rose-a');
var roseB    = G('rose-b');
var roseGrad = G('rose-grad');
var roseRaf  = null;
var roseAct  = roseA, roseSby = roseB;
var rXfade   = false;

function roseTick () {
  var d = roseAct.duration, t = roseAct.currentTime;
  if (!isNaN(d) && d > 0) {
    if (t >= d - XFADE && !rXfade) {
      rXfade = true; roseSby.currentTime = 0; roseSby.play();
    }
    if (rXfade) {
      var p = Math.max(0, Math.min(1, (t - (d - XFADE)) / XFADE));
      roseAct.style.opacity = 1 - p; roseSby.style.opacity = p;
      if (p >= 0.999) {
        roseAct.pause(); roseAct.style.opacity = '0';
        var tmp = roseAct; roseAct = roseSby; roseSby = tmp;
        rXfade = false;
      }
    } else { roseAct.style.opacity='1'; roseSby.style.opacity='0'; }
  }
  roseRaf = requestAnimationFrame(roseTick);
}
function startRose () {
  rXfade = false; roseAct = roseA; roseSby = roseB;
  [roseA, roseB].forEach(function(v){ v.style.display='block'; v.style.opacity='0'; v.pause(); v.currentTime=0; });
  roseGrad.style.opacity = '1';
  roseAct.play().then(function(){ roseAct.style.opacity='1'; cancelAnimationFrame(roseRaf); roseTick(); })
           .catch(function(){      roseAct.style.opacity='1'; cancelAnimationFrame(roseRaf); roseTick(); });
}
function stopRose () {
  cancelAnimationFrame(roseRaf); rXfade = false;
  [roseA, roseB].forEach(function(v){ v.pause(); v.style.opacity='0'; });
  roseGrad.style.opacity = '0';
  setTimeout(function(){ roseA.style.display='none'; roseB.style.display='none'; }, 700);
}

/* ══════════════════════════════════════════════
   EMERALD WADE — BoomerangVideoBg (vanilla JS)
   Mirrors BoomerangVideoBg.tsx exactly:
   1. Hidden <video> plays through once, every frame
      is drawn onto a temp <canvas> and stored.
   2. Once capture ends, RAF renders stored frames
      forward → reverse → forward at 30fps.
   crossOrigin="anonymous" lets drawImage() work.
══════════════════════════════════════════════ */
var emeraldCapture = G('emerald-capture');  /* hidden capture video  */
var emeraldCanvas  = G('emerald-canvas');   /* display canvas        */
var emeraldGrad    = G('emerald-grad');
var emeraldFrames  = [];                    /* cached frame canvases */
var emeraldReady   = false;
var emeraldRaf     = null;
var emeraldCapRaf  = null;
var E_FPS          = 1000 / 30;            /* 30fps = BoomerangVideoBg spec */
var E_MAX_W        = 960;                   /* max capture width     */

function emeraldCaptureFrames (onDone) {
  var video   = emeraldCapture;
  var frames  = [];
  var capActive = true;
  var lastT   = -1;

  function captureFrame () {
    if (!capActive || video.readyState < 2) return;
    if (video.currentTime === lastT)        return;
    lastT = video.currentTime;
    var vw = video.videoWidth, vh = video.videoHeight;
    if (!vw || !vh) return;
    var scale = Math.min(1, E_MAX_W / vw);
    var w = Math.round(vw * scale), h = Math.round(vh * scale);
    var fc = document.createElement('canvas');
    fc.width = w; fc.height = h;
    fc.getContext('2d').drawImage(video, 0, 0, w, h);
    frames.push(fc);
  }

  function rafLoop () {
    captureFrame();
    if (capActive) emeraldCapRaf = requestAnimationFrame(rafLoop);
  }

  function onEnded () {
    video.removeEventListener('ended', onEnded);
    capActive = false;
    cancelAnimationFrame(emeraldCapRaf);
    if (frames.length > 0) {
      emeraldFrames = frames;
      emeraldReady  = true;
      /* Set canvas intrinsic size to match captured frames */
      emeraldCanvas.width  = frames[0].width;
      emeraldCanvas.height = frames[0].height;
      onDone();
    }
  }

  video.addEventListener('ended', onEnded);
  video.currentTime = 0;
  video.play().catch(function(){});
  emeraldCapRaf = requestAnimationFrame(rafLoop);
}

function startEmeraldPlayback () {
  var ctx   = emeraldCanvas.getContext('2d');
  var frms  = emeraldFrames;
  var idx   = 0, dir = 1, last = performance.now();
  cancelAnimationFrame(emeraldRaf);

  function render (now) {
    if (now - last >= E_FPS) {
      last = now;
      ctx.drawImage(frms[idx], 0, 0);
      idx += dir;
      if      (idx >= frms.length - 1) { idx = frms.length - 1; dir = -1; }
      else if (idx <= 0)               { idx = 0;                dir =  1; }
    }
    emeraldRaf = requestAnimationFrame(render);
  }
  emeraldCanvas.style.display = 'block';
  emeraldRaf = requestAnimationFrame(render);
}

function startEmerald () {
  emeraldGrad.style.opacity = '1';
  if (emeraldReady) {
    /* Frames already captured — instant boomerang playback */
    startEmeraldPlayback();
  } else {
    /* First time: show capture video while loading frames */
    emeraldCapture.style.display = 'block';
    emeraldCaptureFrames(function () {
      /* Capture done — hide video, start boomerang canvas */
      emeraldCapture.style.display = 'none';
      startEmeraldPlayback();
    });
  }
}

function stopEmerald () {
  cancelAnimationFrame(emeraldRaf);
  cancelAnimationFrame(emeraldCapRaf);
  emeraldCanvas.style.display  = 'none';
  emeraldCapture.style.display = 'none';
  emeraldGrad.style.opacity    = '0';
}

/* ══════════════════════════════════════════════
   OUD ENIGMA — crossfade video + cinematic hero
   Video: two-video seamless loop (identical to Noir engine).
   Overlay: blur-only mask, NO gradient darkening (per spec).
   Hero: blurFadeUp staggered at 300ms increments.
══════════════════════════════════════════════ */
var oudA      = G('oud-a');
var oudB      = G('oud-b');
var oudBlur   = G('oud-blur-overlay');
var oudCine   = G('oud-cine-hero');
var oudRaf    = null;
var oudAct    = oudA, oudSby = oudB;
var oXfade    = false;

function oudTick () {
  var d = oudAct.duration, t = oudAct.currentTime;
  if (!isNaN(d) && d > 0) {
    if (t >= d - XFADE && !oXfade) {
      oXfade = true; oudSby.currentTime = 0; oudSby.play();
    }
    if (oXfade) {
      var p = Math.max(0, Math.min(1, (t - (d - XFADE)) / XFADE));
      oudAct.style.opacity = 1 - p; oudSby.style.opacity = p;
      if (p >= 0.999) {
        oudAct.pause(); oudAct.style.opacity = '0';
        var tmp = oudAct; oudAct = oudSby; oudSby = tmp;
        oXfade = false;
      }
    } else { oudAct.style.opacity = '1'; oudSby.style.opacity = '0'; }
  }
  oudRaf = requestAnimationFrame(oudTick);
}

function startOud () {
  oXfade = false; oudAct = oudA; oudSby = oudB;
  [oudA, oudB].forEach(function (v) {
    v.style.display = 'block'; v.style.opacity = '0';
    v.pause(); v.currentTime = 0;
  });
  oudBlur.style.opacity = '1';
  oudAct.play().then(function () {
    oudAct.style.opacity = '1'; cancelAnimationFrame(oudRaf); oudTick();
  }).catch(function () {
    oudAct.style.opacity = '1'; cancelAnimationFrame(oudRaf); oudTick();
  });
}

function stopOud () {
  cancelAnimationFrame(oudRaf); oXfade = false;
  [oudA, oudB].forEach(function (v) { v.pause(); v.style.opacity = '0'; });
  oudBlur.style.opacity = '0';
  setTimeout(function () { oudA.style.display = 'none'; oudB.style.display = 'none'; }, 700);
}

/* ── Cinematic hero: populate content + replay blurFadeUp stagger ── */
function showOudCine (perf) {
  /* Metadata row */
  G('oud-meta-row').innerHTML =
    '<span>★&thinsp;4.9 / 5.0</span>' +
    '<span>100ml · Extrait</span>' +
    '<span>Premium Collection</span>';
  /* Title and description from perfume data */
  G('oud-cine-title').textContent = perf.name;
  G('oud-cine-desc').textContent  = perf.tagline;

  /* Reset blurFadeUp: remove .run, force reflow, re-add .run            */
  /* This makes every tab-switch replay the animations from scratch       */
  var bfuEls = oudCine.querySelectorAll('.bfu');
  bfuEls.forEach(function (el) { el.classList.remove('run'); });
  void oudCine.offsetWidth;                       /* reflow */
  bfuEls.forEach(function (el) { el.classList.add('run'); });

  oudCine.classList.add('show');
}

function hideOudCine () {
  oudCine.classList.remove('show');
  /* Reset opacity so elements are invisible when Oud tab is re-entered */
  var bfuEls = oudCine.querySelectorAll('.bfu');
  bfuEls.forEach(function (el) { el.classList.remove('run'); });
}

/* Wire up Previous / Next navigation arrows */
var oudPrevBtn = G('oud-prev-btn');
var oudNextBtn = G('oud-next-btn');
if (oudPrevBtn) oudPrevBtn.onclick = function () { switchTo((active - 1 + P.length) % P.length); };
if (oudNextBtn) oudNextBtn.onclick = function () { switchTo((active + 1) % P.length); };

/* ══════════════════════════════════════════════
   BACKGROUND CROSSFADE — all five video types
══════════════════════════════════════════════ */
var bgA = G('bg-a'), bgB = G('bg-b');
var video = G('hero-video');
var aIsTop = true;

/* ══════════════════════════════════════════════
   OPULENT ROSE — two-video RAF crossfade (same pattern as Noir/Rose)
══════════════════════════════════════════════ */
var opulentA    = G('opulent-a');
var opulentB    = G('opulent-b');
var opulentGrad = G('opulent-grad');
var opulentActive   = opulentA;
var opulentStandby  = opulentB;
var opulentRaf      = null;
var opulentRunning  = false;
var opulentCrossing = false; /* true while crossfade is in progress */
var OPULENT_XFADE   = 1.5;  /* crossfade window in seconds          */

/* ── Three-phase seamless loop ──────────────────────────────────────
   Phase 1 (normal play):
     Active plays at full opacity. Standby is paused, invisible.
   Phase 2 (crossfade begins — OPULENT_XFADE seconds before end):
     Standby starts playing from t=0.
     Active fades out, Standby fades in over OPULENT_XFADE seconds.
   Phase 3 (crossfade complete):
     Old active is paused & reset to 0 (pre-buffered for next cycle).
     Roles are swapped. opulentCrossing = false → back to Phase 1.
──────────────────────────────────────────────────────────────────── */
function startOpulent () {
  if (opulentRunning) return;
  opulentRunning  = true;
  opulentCrossing = false;

  /* Show both elements; only active is visible */
  opulentGrad.style.opacity    = '1';
  opulentActive.style.display  = 'block';
  opulentStandby.style.display = 'block';
  opulentStandby.style.opacity = '0';

  /* Start active from beginning */
  opulentActive.currentTime = 0;
  opulentActive.play().catch(function(){});
  opulentActive.style.opacity = '1';

  function tick () {
    if (!opulentRunning) return;
    var vid  = opulentActive;
    var dur  = vid.duration;

    /* Wait until duration is known */
    if (!dur || isNaN(dur) || dur === Infinity) {
      opulentRaf = requestAnimationFrame(tick);
      return;
    }

    var remaining = dur - vid.currentTime;

    /* ── Phase 2: begin crossfade ── */
    if (!opulentCrossing && remaining <= OPULENT_XFADE) {
      opulentCrossing = true;
      /* Start standby NOW so it has time to buffer */
      opulentStandby.currentTime = 0;
      opulentStandby.play().catch(function(){});
    }

    /* ── Phase 2 ongoing: animate opacity ── */
    if (opulentCrossing) {
      /* t goes 0→1 as remaining goes XFADE→0 */
      var t = Math.max(0, Math.min(1, 1 - (remaining / OPULENT_XFADE)));
      opulentActive.style.opacity  = String((1 - t).toFixed(4));
      opulentStandby.style.opacity = String(t.toFixed(4));

      /* ── Phase 3: crossfade complete ── */
      if (t >= 1 || remaining <= 0.016) {
        opulentActive.style.opacity  = '0';
        opulentStandby.style.opacity = '1';

        /* Pause & reset old active (pre-buffer it for the next cycle) */
        opulentActive.pause();
        opulentActive.currentTime = 0;

        /* Swap roles */
        var tmp        = opulentActive;
        opulentActive  = opulentStandby;
        opulentStandby = tmp;
        opulentCrossing = false;
      }
    }

    opulentRaf = requestAnimationFrame(tick);
  }

  opulentRaf = requestAnimationFrame(tick);
}

function stopOpulent () {
  opulentRunning  = false;
  opulentCrossing = false;
  if (opulentRaf) { cancelAnimationFrame(opulentRaf); opulentRaf = null; }
  opulentA.pause(); opulentA.style.opacity = '0'; opulentA.style.display = 'none';
  opulentB.pause(); opulentB.style.opacity = '0'; opulentB.style.display = 'none';
  opulentA.currentTime = 0;
  opulentB.currentTime = 0;
  opulentGrad.style.opacity = '0';
  /* Reset to default roles for next startOpulent() call */
  opulentActive  = opulentA;
  opulentStandby = opulentB;
}

function setBackground (perf) {
  var next = aIsTop ? bgB : bgA;
  var curr = aIsTop ? bgA : bgB;

  if (perf.videoType === 'noir') {
    video.pause(); video.style.opacity = '0'; stopRose(); stopEmerald(); stopOud(); stopOpulent();
    next.style.background = perf.gradient;
    startNoir();
  } else if (perf.videoType === 'rose') {
    video.pause(); video.style.opacity = '0'; stopNoir(); stopEmerald(); stopOud(); stopOpulent();
    next.style.background = perf.gradient;
    startRose();
  } else if (perf.videoType === 'emerald') {
    video.pause(); video.style.opacity = '0'; stopNoir(); stopRose(); stopOud(); stopOpulent();
    next.style.background = perf.gradient;
    startEmerald();
  } else if (perf.videoType === 'oud') {
    video.pause(); video.style.opacity = '0'; stopNoir(); stopRose(); stopEmerald(); stopOpulent();
    next.style.background = perf.gradient;
    startOud();
  } else if (perf.videoType === 'opulent') {
    video.pause(); video.style.opacity = '0'; stopNoir(); stopRose(); stopEmerald(); stopOud();
    next.style.background = perf.gradient;
    startOpulent();
  } else if (perf.hasVideo) {
    stopNoir(); stopRose(); stopEmerald(); stopOud(); stopOpulent();
    video.style.opacity = '1';
    video.play().catch(function(){});
    next.style.background = '';
  } else {
    video.pause(); video.style.opacity = '0'; stopNoir(); stopRose(); stopEmerald(); stopOud(); stopOpulent();
    next.style.background = perf.gradient;
  }

  next.style.opacity = '1';
  curr.style.opacity = '0';
  aIsTop = !aIsTop;
}

/* ══════════════════════════════════════════════
   RENDER HERO CONTENT
══════════════════════════════════════════════ */
function renderHero (perf) {
  var stdContent = document.querySelector('.hero-content');

  /* Oud Enigma uses the full cinematic movie-style layout     */
  /* All other perfumes use the standard title/tagline layout  */
  if (perf.videoType === 'oud') {
    stdContent.classList.add('oud-mode');
    showOudCine(perf);
  } else {
    stdContent.classList.remove('oud-mode');
    hideOudCine();

    /* Standard hero: title + tagline + CTA */
    var titleEl = G('hero-title');
    titleEl.innerHTML = buildWords(perf.name, 0);
    setTimeout(function () { runWords(titleEl); }, 20);

    var tg = G('hero-tagline'), cta = G('hero-cta');
    tg.textContent = perf.tagline;
    tg.style.color = perf.color;

    [tg, cta].forEach(function (el) {
      el.classList.remove('run');
      void el.offsetWidth;
      el.classList.add('run');
    });
  }

  /* Accent bar always updates regardless of mode */
  G('hero-accent').style.background = perf.accent;
}

/* ══════════════════════════════════════════════
   RENDER DETAIL SECTION
══════════════════════════════════════════════ */
function renderDetail (perf) {
  G('d-super').textContent  = 'Azzurra Parfums · ' + (perf.sub || '');
  G('d-name').textContent   = perf.name;
  G('d-name').style.color   = perf.color;
  G('d-tagline').textContent = perf.italic;
  G('d-tagline').style.color = perf.color;
  /* Concentrate badge */
  var concEl = G('d-conc');
  concEl.querySelector('span:last-child').textContent = perf.conc || '30% Perfume Concentrate';
  concEl.style.color = perf.color;
  G('d-desc').textContent   = perf.desc;
  G('d-price').textContent  = perf.price;
  G('d-price').style.color  = perf.color;
  G('d-top').textContent    = perf.top;
  G('d-top').style.color    = perf.color;
  G('d-heart').textContent  = perf.heart;
  G('d-heart').style.color  = perf.color;
  G('d-base').textContent   = perf.base;
  G('d-base').style.color   = perf.color;

  /* Bottle image + glow */
  var bottleImg = G('d-bottle-img');
  if (bottleImg && perf.img) {
    bottleImg.src = perf.img;
    bottleImg.alt = perf.name;
  }
  var bottleGlow = G('d-bottle-glow');
  if (bottleGlow) bottleGlow.style.background = perf.accent;

  /* Button theme */
  var btn = G('d-btn');
  btn.style.background = perf.color;
  btn.style.color = '#000';
  G('d-btn-circle').style.background = perf.accent;

  /* Section glow */
  G('detail-glow').style.background =
    'radial-gradient(ellipse 70% 60% at 30% 50%, ' + perf.accent + ' 0%, transparent 70%)';

  /* Re-trigger si animations */
  ['detail-left', 'detail-right', 'd-btn'].forEach(function (id) {
    var el = G(id);
    el.classList.remove('run');
    void el.offsetWidth;
    el.classList.add('run');
  });
}

/* ══════════════════════════════════════════════
   SWITCH PERFUME — main function
══════════════════════════════════════════════ */
function switchTo (index) {
  if (index === active || transitioning) return;
  transitioning = true;

  var perf = P[index];
  var titleEl = G('hero-title');
  var rightEl = G('hero-right');

  /* Step 1: Fade OUT current hero content */
  titleEl.classList.add('out');
  rightEl.classList.add('out');

  /* Step 2: Update tabs */
  tabs.forEach(function (t, i) {
    t.classList.toggle('active', i === index);
    t.style.borderBottomColor = i === index ? P[i].color : 'transparent';
  });

  /* Step 3: Crossfade background */
  setBackground(perf);

  /* Step 4: After fade-out, update content and fade IN */
  setTimeout(function () {
    /* Update collection card highlights */
    var cards = grid.querySelectorAll('.coll-card');
    cards.forEach(function (c, i) { c.classList.toggle('active', i === index); });

    active = index;

    /* Remove out class, render new content */
    titleEl.classList.remove('out');
    rightEl.classList.remove('out');
    renderHero(perf);
    renderDetail(perf);

    transitioning = false;
  }, 280);
}

/* ══════════════════════════════════════════════
   INITIAL RENDER
══════════════════════════════════════════════ */
(function init () {
  var perf = P[0];

  /* Set initial background */
  bgA.style.background = perf.gradient;
  video.style.opacity = '1';
  G('hero-accent').style.background = perf.accent;

  /* Build hero */
  renderHero(perf);
  renderDetail(perf);

  /* Fire collection header animations */
  setTimeout(function () {
    runWords(G('coll-title-words'));
    runWords(G('coll-sub-words'));
  }, 200);
  /* Complete Purchase → Shopify checkout */
  var ctaBtn = G("co-cta-btn");
  if (ctaBtn) ctaBtn.onclick = function() {
    var vid = (typeof coPerf !== "undefined" && coPerf && coPerf.variantId)
               ? coPerf.variantId : null;
    var qty = (typeof coQty !== "undefined") ? coQty : 1;
    ctaBtn.disabled = true;
    ctaBtn.innerHTML = "&#x21BB;&ensp;Redirecting to checkout&hellip;";
    ctaBtn.style.background = "";
    if (vid) {
      azShopify.addToCart(vid, qty)
        .then(function(){ window.location.href = "/checkout"; })
        .catch(function(){ window.location.href = "/cart"; });
    } else {
      window.location.href = "/checkout";
    }
  };
})();

/* ══════════════════════════════════════════════
   SCROLL — IntersectionObserver for collection grid
══════════════════════════════════════════════ */
function watch (el, cb, margin) {
  if (!el) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { cb(); io.disconnect(); }
  }, { root: null, threshold: 0.1, rootMargin: margin || '0px' });
  io.observe(el);
}

watch(G('collection'), function () {
  grid.querySelectorAll('.coll-card').forEach(function (c) { c.classList.add('run'); });
  runWords(G('coll-title-words'));
  runWords(G('coll-sub-words'));
}, '-50px');

watch(G('detail'), function () {
  ['detail-left','detail-right','d-btn'].forEach(function (id) {
    var el = G(id); if (el) el.classList.add('run');
  });
}, '-80px');

/* ══════════════════════════════════════════════
   PRODUCT DETAIL PAGE  (PDP) + CHECKOUT
   ─────────────────────────────────────────────
   openPDP(perf)         — slides in from right
   closePDP()            — slides out
   openCheckout(p,size)  — slides over PDP
   closeCheckout()       — slides back
   updateCoPrice()       — recalculates total
   ─────────────────────────────────────────────
   Entry points:
     Hero "Explore Scent"  → openPDP
     Oud "Discover Scent"  → openPDP
     Collection cards      → openPDP
     Detail "Add to Coll." → openCheckout (100ml)
     PDP  "Add to Cart"    → openCheckout
     PDP  "Buy Now"        → openCheckout
══════════════════════════════════════════════ */
var SIZES = [
  { label: '100ml', price: 89.99 }
];

var pdpEl   = G('pdp');
var coEl    = G('checkout');
var pdpPerf = null;       /* perfume currently shown in PDP       */
var pdpSize = '100ml';    /* size selected in PDP                 */
var coPerf  = null;       /* perfume currently shown in Checkout  */
var coSize  = '100ml';    /* size selected in Checkout            */
var coQty   = 1;          /* quantity in Checkout                 */

function fmtPrice (n) { return '$' + parseFloat(n).toFixed(2); }

/* ─── OPEN PDP ─── */
function openPDP (perf) {
  pdpPerf = perf;
  pdpSize = '100ml';

  /* Bottle + glow */
  var bottleEl = G('pdp-bottle');
  bottleEl.src = perf.img || '';
  bottleEl.alt = perf.name;
  /* Re-trigger entrance animation each open */
  bottleEl.style.animation = 'none';
  void bottleEl.offsetWidth;
  bottleEl.style.animation = '';

  G('pdp-blob').style.background = perf.accent;

  /* Text fields */
  G('pdp-super').textContent  = 'Azzurra Parfums · ' + (perf.sub || '');
  G('pdp-name').textContent   = perf.name;
  G('pdp-name').style.color   = perf.color;
  G('pdp-italic').textContent = perf.italic;
  G('pdp-italic').style.color = perf.color;
  G('pdp-conc-dot').style.background = perf.accent;
  G('pdp-conc-text').textContent = perf.conc || '30% Perfume Concentrate';
  G('pdp-desc').textContent   = perf.desc;
  G('pdp-top').textContent    = perf.top;
  G('pdp-heart').textContent  = perf.heart;
  G('pdp-base').textContent   = perf.base;

  /* Size buttons */
  var sizesEl = G('pdp-sizes');
  sizesEl.innerHTML = '';
  SIZES.forEach(function (s) {
    var btn = document.createElement('button');
    btn.className = 'pdp-size-btn' + (s.label === pdpSize ? ' active' : '');
    if (s.label === pdpSize) {
      btn.style.borderColor = perf.accent;
      btn.style.color       = perf.color;
    }
    btn.textContent = s.label;
    btn.onclick = function () {
      pdpSize = s.label;
      sizesEl.querySelectorAll('.pdp-size-btn').forEach(function (b) {
        b.classList.remove('active');
        b.style.borderColor = '';
        b.style.color = '';
      });
      btn.classList.add('active');
      btn.style.borderColor = perf.accent;
      btn.style.color = perf.color;
      /* Update displayed price */
      G('pdp-price').textContent = fmtPrice(s.price);
    };
    sizesEl.appendChild(btn);
  });

  /* Price chip — show selected size price */
  var selectedSize = SIZES.find(function (s) { return s.label === pdpSize; }) || SIZES[0];
  G('pdp-price').textContent = fmtPrice(selectedSize.price);

  /* Slide in */
  document.body.style.overflow = 'hidden';
  pdpEl.classList.add('open');
}

/* ─── CLOSE PDP ─── */
function closePDP () {
  pdpEl.classList.remove('open');
  /* Restore scroll only when checkout is also closed */
  if (!coEl.classList.contains('open')) {
    document.body.style.overflow = '';
  }
}

/* ─── UPDATE CHECKOUT PRICE ─── */
function updateCoPrice () {
  var s = SIZES.find(function (x) { return x.label === coSize; }) || SIZES[0];
  var total = parseFloat((s.price * coQty).toFixed(2));
  G('co-qty-num').textContent         = coQty;
  G('co-product-price').textContent   = fmtPrice(s.price) + ' / bottle';
  G('co-subtotal').textContent        = fmtPrice(total);
  G('co-total').textContent           = fmtPrice(total);
  var ctaPrice = G('co-cta-price');
  if (ctaPrice) ctaPrice.textContent  = fmtPrice(total);
}

/* ─── OPEN CHECKOUT ─── */
function openCheckout (perf, size) {
  coPerf = perf;
  coSize = size || '100ml';
  coQty  = 1;

  /* Product summary card */
  G('co-bottle-thumb').src      = perf.img || '';
  G('co-bottle-thumb').alt      = perf.name;
  G('co-product-name').textContent = perf.name;
  G('co-product-sub').textContent  = perf.sub || 'Extrait de Parfum · Unisex';

  /* Size buttons */
  var sizesEl = G('co-sizes');
  sizesEl.innerHTML = '';
  SIZES.forEach(function (s) {
    var btn = document.createElement('button');
    btn.className = 'co-size-btn' + (s.label === coSize ? ' active' : '');
    btn.innerHTML =
      '<span class="co-size-label">' + s.label + '</span>' +
      '<span class="co-size-price">' + fmtPrice(s.price) + '</span>';
    btn.onclick = function () {
      coSize = s.label;
      sizesEl.querySelectorAll('.co-size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updateCoPrice();
    };
    sizesEl.appendChild(btn);
  });

  updateCoPrice();
  coEl.classList.add('open');
}

/* ─── CLOSE CHECKOUT ─── */
function closeCheckout () {
  coEl.classList.remove('open');
}

/* ─── QUANTITY STEPPER ─── */
G('co-qty-minus').onclick = function () {
  if (coQty > 1) { coQty--; updateCoPrice(); }
};
G('co-qty-plus').onclick = function () {
  if (coQty < 9) { coQty++; updateCoPrice(); }
};

/* ─── CHECKOUT BACK → return to PDP ─── */
G('co-back').onclick = function () { closeCheckout(); };

/* ─── COMPLETE PURCHASE ─── */
G('co-cta-btn').onclick = function () {
  /* Always use the perfume that opened this overlay (coPerf),
     falling back to whichever tab is active (P[active]).        */
  var perf = (typeof coPerf !== 'undefined' && coPerf) ? coPerf : P[active];
  var vid  = perf && perf.variantId ? perf.variantId : null;
  var qty  = (typeof coQty !== 'undefined' && coQty > 0) ? coQty : 1;
  var btn  = G('co-cta-btn');

  btn.disabled = true;
  btn.innerHTML = '&#x21BB;&ensp;Redirecting to checkout&hellip;';

  if (!vid) {
    /* No variant linked in Theme Customizer yet */
    window.location.href = '/checkout';
    return;
  }

  /* Clear cart first so ONLY the selected item goes to checkout
     (prevents stale test items showing as the wrong product).   */
  fetch('/cart/clear.js', { method: 'POST' })
    .then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      });
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function () {
      window.location.href = '/cart';
    });
};

/* ─── PDP BACK BUTTON ─── */
G('pdp-back').onclick = closePDP;

/* ─── PDP "ADD TO CART" → Checkout ─── */
G('pdp-add-btn').onclick = function () {
  if (pdpPerf) openCheckout(pdpPerf, pdpSize);
};

/* ─── PDP "BUY NOW" → Checkout ─── */
G('pdp-buy-btn').onclick = function () {
  if (pdpPerf) openCheckout(pdpPerf, pdpSize);
};

/* ─── HERO "EXPLORE SCENT" → PDP ─── */
G('hero-cta').onclick = function () { openPDP(P[active]); };

/* ─── DETAIL SECTION "ADD TO COLLECTION" → Checkout at 100ml ─── */
G('d-btn').onclick = function () { openCheckout(P[active], '100ml'); };

/* ─── OUD CINE "DISCOVER SCENT" → PDP ─── */
if (G('oud-watch-btn')) {
  G('oud-watch-btn').onclick = function () { openPDP(P[active]); };
}

/* ─── OUD CINE "EXPLORE NOTES" → scrolls to detail section ─── */
/* (this button already has inline onclick so it keeps working) */


/* ═══ SHOPIFY BUTTON OVERRIDES ═══════════════════════════════
   On Shopify: redirect to native cart/checkout.
   On standalone demo: use original openCheckout overlay.
════════════════════════════════════════════════════════════ */
(function() {
  /* PDP Buy Now */
  var buyBtn = G("pdp-buy-btn");
  if (buyBtn) buyBtn.onclick = function() {
    var perf = pdpPerf;
    if (!perf) return;
    if (azShopify.isShopify && perf.variantId) {
      var b = G("pdp-buy-btn"); b.disabled = true; b.textContent = "Redirecting...";
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() { return azShopify.addToCart(perf.variantId, 1); })
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ b.textContent = 'Buy Now'; b.disabled = false; });
    } else if (perf.productUrl) { window.location.href = perf.productUrl; }
    else if (typeof openCheckout === "function") { openCheckout(perf, pdpSize); }
  };
  /* PDP Add to Cart */
  var addBtn = G("pdp-add-btn");
  if (addBtn) addBtn.onclick = function() {
    var perf = pdpPerf;
    if (!perf) return;
    if (azShopify.isShopify && perf.variantId) { azShopify.addAndNotify(perf.variantId, 1); }
    else if (typeof openCheckout === "function") { openCheckout(perf, pdpSize); }
  };
  /* Detail Add to Collection */
  var dBtn = G("d-btn");
  if (dBtn) dBtn.onclick = function() {
    var perf = P[active];
    if (!perf) return;
    if (azShopify.isShopify && perf.variantId) {
      var b = G("d-btn"); b.disabled = true; b.textContent = "Adding...";
      azShopify.addToCart(perf.variantId, 1).then(function() {
        b.textContent = "Added!"; b.style.background = "#5dbd79";
        setTimeout(function(){ b.style.background=""; b.disabled=false;
          b.innerHTML="Add to Collection <span class=\"buy-circle\" id=\"d-btn-circle\"></span>";
          G("d-btn-circle") && (G("d-btn-circle").style.background = perf.accent);
        }, 2200);
      }).catch(function(){ b.disabled=false; b.textContent="Add to Collection"; });
    } else if (perf.productUrl) { window.location.href = perf.productUrl; }
    else if (typeof openCheckout === "function") { openCheckout(perf, "100ml"); }
  };
})();


/* ══════════════════════════════════════════════
   POPUP SYSTEM — footer links
══════════════════════════════════════════════ */
var AZ_POPUPS = {

  'our-story': function() { return '<h2>Our Story</h2><p class="popup-sub">Azzurra Parfums · Est. 2022</p><p>Azzurra was born from a single conviction: that fragrance is one of the last truly personal luxuries. In a world of mass-produced scents, we set out to create something different — perfumes crafted with the same reverence given to rare wines or bespoke tailoring.</p><p>Our founders spent three years travelling the ancient trade routes of the Middle East, North Africa, and the Mediterranean, sourcing ingredients that most commercial perfumers have never encountered. Agarwood from the forests of Assam. Rose absolute from the valleys of Grasse. Ambergris from the shores of the Atlantic. Each ingredient chosen not for its price tag, but for its story.</p><div class="popup-divider"></div><div class="popup-grid"><div class="popup-card"><h4>Our Philosophy</h4><p>Every bottle holds a world. We create fragrances that evolve throughout the day — opening notes that intrigue, heart notes that captivate, base notes that linger long after you leave the room.</p></div><div class="popup-card"><h4>Our Commitment</h4><p>No synthetic shortcuts. No mass-market compromises. Every Azzurra fragrance is crafted at 30% concentration — Extrait de Parfum — the highest grade in perfumery.</p></div></div><p>Today, Azzurra is worn in over 40 countries by those who refuse to wear what everyone else wears. By those who understand that the most powerful accessory you can wear is one nobody else can see.</p><p style="font-style:italic;opacity:0.5">— The Azzurra Founders</p>'; },

  'heritage': function() { return '<h2>Heritage Notes</h2><p class="popup-sub">The Art of Perfumery</p><p>Perfumery is one of humanity\'s oldest arts — practiced for over 4,000 years in ancient Egypt, Mesopotamia, and Arabia. Azzurra draws deeply from this heritage, interpreting ancient aromatic traditions through a modern lens.</p><p>Each fragrance in our collection is rooted in a specific cultural heritage: the smoky oud of the Arabian peninsula, the citrus groves of the Mediterranean coast, the dense forests of South Asia. We don\'t manufacture scents — we rediscover them.</p><div class="popup-card"><h4>Extrait de Parfum</h4><p>All Azzurra fragrances are formulated at 30% concentration — the Extrait de Parfum grade. This is perfumery at its most potent and pure. A single application lasts 12–24 hours.</p></div>'; },

  'scent-library': function() { return '<h2>Scent Library</h2><p class="popup-sub">Discover the Collection</p><p>The Azzurra Scent Library is an evolving archive of fragrance knowledge — from the raw ingredients we source to the olfactory families each perfume belongs to.</p><div class="popup-grid"><div class="popup-card"><h4>Oud & Resins</h4><p>The ancient heart of Arabic perfumery. Rich, deep, and spiritually grounding.</p></div><div class="popup-card"><h4>Citrus & Marine</h4><p>The luminous opening of Mediterranean summers. Fresh, immediate, and alive.</p></div><div class="popup-card"><h4>Florals</h4><p>From the velvety rose to the intoxicating jasmine — flowers in their purest form.</p></div><div class="popup-card"><h4>Gourmand & Amber</h4><p>Warm, enveloping, sensual. The scents that stay closest to the skin.</p></div></div>'; },

  'artisans': function() { return '<h2>The Artisans</h2><p class="popup-sub">Hands Behind Every Bottle</p><p>Every Azzurra fragrance passes through the hands of master perfumers, glassblowers, and craftspeople who have spent lifetimes perfecting their art. We partner only with family-run ateliers — people for whom craft is not a job, but an inheritance.</p><p>Our glass bottles are blown in a fourth-generation workshop in Valencia. Our caps are hand-turned from sustainable hardwood in Portugal. The packaging is printed using zero-solvent inks on FSC-certified paper in a small press in Lyon.</p><p>Luxury, to us, means knowing exactly where everything comes from.</p>'; },

  'collective': function() { return '<h2>The Collective</h2><p class="popup-sub">Community · Culture · Fragrance</p><p>The Azzurra Collective is our growing community of fragrance lovers, collectors, and connoisseurs. Members receive early access to new releases, invitations to exclusive events, and insights from our master perfumers.</p><p>Join over 12,000 members worldwide who share a passion for extraordinary fragrance.</p><a href="mailto:collective@azzurraparfums.com" class="popup-cta">Join the Collective</a>'; },

  'newsroom': function() { return '<h2>Newsroom</h2><p class="popup-sub">Press & Media</p><p>Azzurra has been featured in Vogue Arabia, Harper\'s Bazaar, Wallpaper*, and GQ. For press enquiries, interview requests, or sample kits, please reach out to our communications team.</p><a href="mailto:press@azzurraparfums.com" class="popup-cta">Contact Press Team</a>'; },

  'join': function() { return '<h2>Join the Team</h2><p class="popup-sub">Open Positions</p><p>We\'re always looking for exceptional people who share our obsession with quality, craft, and storytelling. If you\'re passionate about fragrance and luxury, we\'d love to hear from you.</p><p>Current openings: Brand Storyteller · Retail Experience Designer · Fragrance Consultant · Digital Marketing Lead</p><a href="mailto:careers@azzurraparfums.com" class="popup-cta">Send Your Application</a>'; },

  'contact': function() { return '<h2>Get in Touch</h2><p class="popup-sub">We\'d love to hear from you</p><p>For orders, gifting enquiries, or anything else — our team responds within 24 hours.</p><input class="popup-contact-field" type="text" placeholder="Your name"><input class="popup-contact-field" type="email" placeholder="Your email"><textarea class="popup-contact-field" rows="4" placeholder="Your message..."></textarea><button class="popup-cta" onclick="alert(\'Thank you — we\'ll be in touch within 24 hours.\');return false;">Send Message</button>'; },

  'privacy': function() { return '<h2>Privacy Policy</h2><p class="popup-sub">Last updated: 2024</p><p>Azzurra Parfums is committed to protecting your personal information. We collect only what is necessary to process your orders and improve your experience.</p><p><strong>What we collect:</strong> Name, email, shipping address, and payment information (processed securely by Shopify — we never store card details).</p><p><strong>What we never do:</strong> Sell your data. Share it with third parties for marketing. Use it for anything beyond fulfilling your order and communicating with you.</p><p><strong>Cookies:</strong> We use essential cookies for the store to function and optional analytics cookies to understand how people use the site. You can opt out at any time.</p><p>For any privacy requests, contact <a href="mailto:privacy@azzurraparfums.com" style="color:inherit">privacy@azzurraparfums.com</a>.</p>'; },

  'terms': function() { return '<h2>Terms & Conditions</h2><p class="popup-sub">Last updated: 2024</p><p><strong>Orders:</strong> All orders are subject to product availability. We reserve the right to cancel orders due to pricing errors or stock issues, in which case you will be fully refunded.</p><p><strong>Returns:</strong> Unopened bottles may be returned within 30 days of receipt. Opened bottles are non-returnable for hygiene reasons, unless faulty.</p><p><strong>Shipping:</strong> Orders are dispatched within 2–3 business days. International delivery typically takes 5–10 business days. Customs duties are the responsibility of the recipient.</p><p><strong>Authenticity:</strong> All Azzurra products are genuine and sourced directly from our production partners. We do not authorise third-party resellers.</p>'; },

  'feedback': function() { return '<h2>Feedback</h2><p class="popup-sub">Help us improve</p><p>Your experience with Azzurra matters deeply to us. Whether it\'s about our fragrances, packaging, website, or service — we want to hear it all.</p><textarea class="popup-contact-field" rows="5" placeholder="Share your thoughts..."></textarea><button class="popup-cta" onclick="alert(\'Thank you for your feedback.\');return false;">Submit Feedback</button>'; },

  'coming-soon': function() { return '<h2>Coming Soon</h2><p class="popup-sub">Something extraordinary is on its way</p><p>We\'re working on something new. Sign up to be the first to know when it launches.</p><input class="popup-contact-field" type="email" placeholder="Your email address"><button class="popup-cta" onclick="alert(\'You\'re on the list.\');return false;">Notify Me</button>'; },

  'collections': function() { return '<h2>Collections</h2><p class="popup-sub">All Azzurra Fragrances</p><p>Explore the full Azzurra collection — six fragrances, six worlds, one house. Each scent tells a different story, carries a different memory, opens a different door.</p><p>Scroll up to discover each fragrance in detail — or browse the collection grid below the hero section.</p>'; },
};

/* Open popup */
function openPopup(id) {
  var fn = AZ_POPUPS[id];
  if (!fn) return;
  var el   = document.getElementById('az-popup');
  var cont = document.getElementById('az-popup-content');
  if (!el || !cont) return;
  cont.innerHTML = fn();
  el.classList.add('open');
  document.body.style.overflow = 'hidden';
}

/* Close popup */
function closePopup() {
  var el = document.getElementById('az-popup');
  if (!el) return;
  el.classList.remove('open');
  document.body.style.overflow = '';
}

/* Wire up all popup links and close buttons */
(function() {
  document.addEventListener('click', function(e) {
    /* Footer popup links */
    if (e.target.classList && e.target.classList.contains('az-popup-link')) {
      e.preventDefault();
      openPopup(e.target.getAttribute('data-popup'));
      return;
    }
    /* Close button */
    if (e.target.id === 'az-popup-close') { closePopup(); return; }
    /* Backdrop click */
    if (e.target.id === 'az-popup-backdrop') { closePopup(); return; }
  });
  /* ESC key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup();
  });
})();


}());